import { CircularLoader, ModalContainer, ModalTitle } from '@medeloop/medeloop-components-library';
import { useState } from 'react';
import { useCohortOrganizationUnitSyncMutation } from 'src/api/cohorts-queries';
import { MultiSelect } from 'src/components/common/multi-select';
import { to } from 'to-await';

type AssignCohortModalProps = {
  cohortId?: string;
  dataSourceId?: string;
  onClose: () => void;
  organizationUnitOptions?: { label: string; value: string }[];
  selectedValues?: string[];
};

export const AssignCohortModal = ({
  onClose,
  organizationUnitOptions = [],
  selectedValues = [],
  cohortId,
  dataSourceId,
}: AssignCohortModalProps) => {
  const [organizationUnitIds, setOrganizationUnitIds] = useState<string[]>(selectedValues ?? []);
  const { isPending, mutateAsync: cohortOrganizationUnitSync } =
    useCohortOrganizationUnitSyncMutation();

  const handleSave = async () => {
    const [error] = await to(
      cohortOrganizationUnitSync({
        dataSourceId,
        cohortId,
        organizationUnitIds,
      }),
    );

    if (error) {
      return;
    }

    onClose();
  };

  const handleChange = (value: string[]) => {
    setOrganizationUnitIds(value);
  };

  return (
    <ModalContainer className="min-w-[428px] flex flex-col" onClose={onClose}>
      <ModalTitle> Assign Cohort </ModalTitle>

      <div className="w-full flex flex-col space-y-2">
        <h2 className="text-sm leading-5 text-content-on-dark-default max-sm:text-xs">
          Organization or Organization Units
        </h2>
        <MultiSelect
          onChange={handleChange}
          placeholder="Select researchers' organization units"
          options={organizationUnitOptions}
          selectedValues={organizationUnitIds}
        />
      </div>

      <div className="flex justify-end gap-4 mt-4">
        <button
          className="w-24 rounded-full border border-cool-gray-600 flex items-center justify-center px-4 py-2"
          onClick={onClose}
        >
          Cancel
        </button>

        <button
          className="w-24 bg-primary-background-default hover:bg-primary-background-hover text-black font-medium px-4 py-2 rounded-full text-md border border-stroke-on-dark-subdued"
          onClick={handleSave}
        >
          {isPending ? <CircularLoader /> : <span> Assign </span>}
        </button>
      </div>
    </ModalContainer>
  );
};
